import Vue from 'vue'
import App from './App.vue'
import store from './store'
import "./main.scss";

Vue.config.productionTip = true
Vue.config.devtools = true

window.roofingData = roofing_vars

new Vue({
  store,
  render: h => h(App),
  el: document.querySelector('#app'),
})
